import { Globe } from "lucide-react";

import { LOCALE_LABELS, SUPPORTED_LOCALES, type SupportedLocale } from "@/i18n";
import { useLocale } from "@/i18n/provider";

export function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();
  return (
    <label className="inline-flex items-center gap-1.5 rounded-md border border-[var(--color-border)] bg-[var(--color-surface)] px-2 py-1 text-[11px] text-[var(--color-text-secondary)]">
      <Globe size={12} aria-hidden />
      <span className="sr-only">Idioma</span>
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value as SupportedLocale)}
        aria-label="Seleccionar idioma"
        className="bg-transparent font-[var(--font-mono)] text-[11px] focus:outline-none"
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l} value={l} className="bg-[var(--color-surface)]">
            {LOCALE_LABELS[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
